import React from 'react';
import { BrowserRouter, Routes, Route, Navigate } from 'react-router-dom';
import { ToastContainer } from 'react-toastify';
import { AuthProvider, useAuth } from './context/AuthContext';
import { ThemeProvider } from './context/ThemeContext';
import Layout from './components/layout/Layout';
import LoginPage from './pages/LoginPage';
import RegisterPage from './pages/RegisterPage';
import DashboardPage from './pages/DashboardPage';
import CalendarPage from './pages/CalendarPage';
import MenuPage from './pages/MenuPage';
import ShoppingPage from './pages/ShoppingPage';
import FinanceHub from './pages/FinanceHub';
import FamilyPage from './pages/FamilyPage';
import ProfilePage from './pages/ProfilePage';
import SetupPage from './pages/SetupPage';
import SchoolSyncPage from './pages/SchoolSyncPage';
import SchoolSchedulePage from './pages/SchoolSchedulePage';
import TrainingPage from './pages/TrainingPage';

function PrivateRoute({ children }) {
  const { isAuthenticated } = useAuth();
  return isAuthenticated ? children : <Navigate to="/login" replace />;
}

function PublicRoute({ children }) {
  const { isAuthenticated } = useAuth();
  return !isAuthenticated ? children : <Navigate to="/" replace />;
}

function AppRoutes() {
  return (
    <Routes>
      <Route path="/login" element={<PublicRoute><LoginPage /></PublicRoute>} />
      <Route path="/register" element={<PublicRoute><RegisterPage /></PublicRoute>} />
      <Route path="/setup" element={<SetupPage />} />
      <Route path="/" element={<PrivateRoute><Layout /></PrivateRoute>}>
        <Route index element={<DashboardPage />} />
        <Route path="calendar" element={<CalendarPage />} />
        <Route path="menu" element={<MenuPage />} />
        <Route path="shopping" element={<ShoppingPage />} />
        <Route path="finances" element={<FinanceHub />} />
        <Route path="subscriptions" element={<Navigate to="/finances?tab=suscripciones" replace />} />
        <Route path="credits" element={<Navigate to="/finances?tab=creditos" replace />} />
        <Route path="family" element={<FamilyPage />} />
        <Route path="profile" element={<ProfilePage />} />
        <Route path="school-sync" element={<SchoolSyncPage />} />
        <Route path="school-schedule" element={<SchoolSchedulePage />} />
        <Route path="school-training" element={<TrainingPage />} />
      </Route>
    </Routes>
  );
}

export default function App() {
  return (
    <ThemeProvider>
      <AuthProvider>
        <BrowserRouter>
          <AppRoutes />
          <ToastContainer position="top-right" autoClose={3000} hideProgressBar={false} />
        </BrowserRouter>
      </AuthProvider>
    </ThemeProvider>
  );
}
